import React from 'react';
import { Button, SelectList } from '..';
import IconComponent from '../../Icon';

export const Controls = ({ filters, canAdd, addText, onClick }) => (
    <>
        {filters.map((filter, index) => (
            <div key={`filter${index}`} className="w-2/6">
                <SelectList
                    placeholder={filter.placeholder}
                    onChange={filter.onChange}
                    options={filter.options}
                    defaultValue={filter.defaultValue}
                    isClearable={filter.isClearable}
                />
            </div>
        ))}
        {canAdd ? (
            <div key="create" className="w-2/6 flex justify-end">
                <Button type="primary" onClick={onClick}>
                    <IconComponent colour="text-white" width="10" height="10" icon="add" />
                    {addText}
                </Button>
            </div>
        ) : (
            <></>
        )}
    </>
);

export const getRowProps = (row, onRowClick, hoveredRow, setHoveredRow) => {
    if (row) {
        return {
            onMouseEnter: () => {
                setHoveredRow(row.index);
            },
            onMouseLeave: () => {
                setHoveredRow(null);
            },
            onClick: () => onRowClick(row),
            style: {
                cursor: 'pointer',
                background: row.index === hoveredRow ? '#A4DEFF' : 'white',
            },
        };
    }
};
